import React, { Component } from "react";
import Modal, { MODAL_SIZE } from "@acadia-ui/modal";
import Button from "@acadia-ui/button";
import "./modal.scss";
import ModalHelpers from "./ModalHelpers";
import FormBuilderV2 from "../../Components/FormBuilder/FormBuilderV2";
import AdvertiserFormBuilder from "../../Components/FormBuilder/AdvertiserFormBuilder";
import UpdateStateHelper from "../../Components/FormBuilder/UpdateStateHelper";
import ErrorHelpers from "../../Components/FormBuilder/ErrorHelpers";
import Dropdown from "@acadia-ui/dropdown";
import BookFiltersStore from "../../Flux/Stores/BookFiltersStore";
import MasterCampaignsStore from "../../Flux/Stores/MasterCampaignsStore";
import { editCampaignData, fetchAdvertiserTaxonomy, createAdvertisers } from "../../Flux/Actions/MasterCampaignActions";
import Loading from "../../Components/LoadingSpinner";
import moment from "moment";
import { ToastContainer, ToastNotification, showToast } from "@acadia-ui/toast";
import AccessPermissions from "../../Components/FormBuilder/AccessPermissions";
import "./EditMasterCampaignV2.scss";

const initialState = {
	formData: {},
	postData: {},
	errors: {},
	showErrors: false,
	isFormDataValid: false,
	isFormInitialLoad: true
};

const formEl = "edit__master__campaign";

class EditMasterCampaign extends Component {
	constructor(props) {
		super(props);
		this.rowCount = 0;
		this.pendingMasterCampaignSuccess = false;
		this.state = {
			...initialState,
			additionalRows: [
				// {
				// 	id: this.rowCount,
				// 	platformsDisabled: true
				// }
			],
			mediaChannelsPlatforms: this.props.mediaChannelsPlatforms,
			excludedPlatformIDs: [],
			disabledRows: 0,
			loading: false,
			totalAdvertisers: 0,
			advertiserFields: {},
			advertisersErrors: {},
			loadedAdvertiserIds: [],
			permissionedOptions: {}
		};
	}

	componentDidMount() {
		this.props.editMasterRef(this);
		MasterCampaignsStore.on("error_edit", this.handleErrors);
		MasterCampaignsStore.on("success_edit", this.handleSuccess);
		MasterCampaignsStore.on("campaign__errors__reset", this.handleReset);
		// MasterCampaignsStore.on("advertisers_updated_success", this.handleAdvertiserSuccess);
		MasterCampaignsStore.on("advertisers_updated_bulk_fail", this.handleAdvertiserErrors);

		// this.setState({ advertiserFields: MasterCampaignsStore.getAdvertiserFields() });
	}

	componentWillUnmount() {
		this.props.editMasterRef(undefined);
		MasterCampaignsStore.removeListener("error_edit", this.handleErrors);
		MasterCampaignsStore.removeListener("success_edit", this.handleSuccess);
		MasterCampaignsStore.removeListener("campaign__errors__reset", this.handleReset);
		// MasterCampaignsStore.removeListener("advertisers_updated_success", this.handleAdvertiserSuccess);
		MasterCampaignsStore.removeListener("advertisers_updated_bulk_fail", this.handleAdvertiserErrors);
	}

	filterPlatforms = (arrayList) => {
		if (arrayList.length > 0) {
			const options = [];
			arrayList.forEach((platform) => {
				if (!this.state.excludedPlatformIDs.includes(platform.MasterPlatformID)) {
					options.push({ value: platform.MasterPlatformID, label: platform.PlatformName });
				}
			});
			return options;
		}
		return [];
	};

	isFormValid = () => {
		let permissionedValuesSelected = true;
		if (Object.keys(this.props.permissionedDataKeys).length) {
			const selectedPermissions = [];
			Object.values(this.state.permissionedOptions).forEach((dataValues) => {
				selectedPermissions.push(...dataValues);
			});
			if (!selectedPermissions.length) {
				permissionedValuesSelected = false;
			}
		}
		if (
			this.state.formData?.MasterCampaignName?.value.length > 0 &&
			this.state.formData?.Platform_0?.length > 0 &&
			!this.state.isFormInitialLoad &&
			permissionedValuesSelected
		) {
			this.setState({ isFormDataValid: true });
		} else {
			this.setState({ isFormDataValid: false });
		}
		if (this.state.isFormInitialLoad) {
			this.setState({ isFormInitialLoad: false });
		}
	};

	onMultiSelectPlatformChange = async (selections) => {
		// map the campaign level selection to any available advertisers
		let advertisers = MasterCampaignsStore.getAdvertiserFields();
		let platformsToFetch = [];
		selections?.forEach((option) => {
			if (!advertisers[option.label]) {
				const matchedAdvertiser = MasterCampaignsStore.getAdvertisers().find(({ MasterPlatformID }) => MasterPlatformID === option.value);
				const isEnabled = this.props.enabledPlatformAPIs?.find(({ MasterPlatformID }) => MasterPlatformID === matchedAdvertiser?.MasterPlatformID)?.SyncStatus === false;
				if (matchedAdvertiser && isEnabled) {
					platformsToFetch.push(matchedAdvertiser);
				}
			}
		});

		// request advertiser fields for newly selected platforms
		await this.fetchAdvertiserFields(platformsToFetch);

		// update form data state
		const updateFormData = this.state.formData;
		updateFormData[`Platform_${0}`] = selections;
		this.setState(
			{
				formData: updateFormData
			},
			() => {
				this.updateCustomState("CampaignConfig", `Platform_${0}`, selections, `Platform_${0}`, "excludeID");
			}
		);
	};

	updateState = (dataConfig, name, value, id, dataType, calc, disabled) => {
		// if (this.state.loading === false) {
		UpdateStateHelper.update(dataConfig, name, value, id, dataType, true, formEl, this, disabled, this.props.config, false, this.isFormValid);
		// }
	};

	updateCustomState = (dataConfig, name, value, id, type) => {
		// Check if we have anything in the bucket first, if not just create an empty object so it doesn't bomb out
		const postDataBucket = this.state.postData[dataConfig] ? this.state.postData[dataConfig] : {};

		// Set Default Variable
		const postDataValue = value;

		// We want Numbers to fallback to 0 for POST purposes
		// if (dataType === 'Currency' || dataType === 'Integer') {
		// 	postDataValue = value || 0;
		// } else {
		// 	postDataValue = value || null;
		// }

		// If we have a nested value it's a dropdown object so let's get the ID for the POST
		// if (postDataValue) {
		// 	if (postDataValue.value) {
		// 		postDataValue = postDataValue.value;
		// 	}
		// }
		let formDataObject = {
			...this.state.formData,
			[name]: {
				value: postDataValue
			}
		};
		if (type === "clearPlatform") {
			formDataObject = {
				...this.state.formData,
				[name]: {
					value: postDataValue
				},
				[`${id}`]: null
			};
			Object.assign(postDataBucket, { [name]: postDataValue });
		} else {
			Object.assign(postDataBucket, { [name]: postDataValue });
		}

		this.setState(
			{
				// formData: formDataObject,
				postData: {
					...this.state.postData,
					[dataConfig]: postDataBucket
				}
			},
			() => {
				let excludedIDs = this.state.excludedPlatformIDs;
				if (type === "excludeID") {
					if (postDataValue) {
						excludedIDs = this.rebuildExclusionList();
					} else {
						excludedIDs = this.removePlatformFromExclusion(id);
					}
				}
				this.setState({
					excludedPlatformIDs: excludedIDs
				});
				this.isFormValid();
			}
		);
	};

	returnPlatformIds = (newRowObj) => {
		const platformIds = [];
		const formData = Object.entries(newRowObj);
		formData.forEach((element) => {
			if (element[0].indexOf("Platform") !== -1) {
				element[1].forEach((x) => {
					platformIds.push(x.value);
				});
			}
		});
		return platformIds.join(",");
	};

	/* This should be a helper object that formats POST JSON for the PUT Actions */
	formDataObjForPost = (newRowObj) => {
		if (Object.keys(newRowObj).length > 0) {
			const contextValues = BookFiltersStore.getContextValues();
			const postData = this.state.postData.CampaignConfig;

			/* Platform Ids will need a concatenation or something later */
			const PlatformIds = this.returnPlatformIds(newRowObj);

			const permissionedOptions = [];
			Object.keys(this.state.permissionedOptions).forEach((dataKey) => {
				this.state.permissionedOptions[dataKey].forEach((option) => {
					permissionedOptions.push(option.DataValue_MDM_GUID);
				});
			});

			const formSubmissionObj = {
				MasterAgencyDivisionName: contextValues?.agency?.name,
				MasterBusinessUnitName: contextValues?.client?.name,
				MasterCountryCode: contextValues?.country?.name,
				MasterRegionCode: contextValues?.region?.name,
				ContextID: contextValues.contextId,
				PlatformIds,
				MasterCampaignName: newRowObj.MasterCampaignName.value,
				MasterCampaignID: this.props.data.MasterCampaignUniqueIDCode,
				DataValue_MDM_GUIDs: permissionedOptions.join(),
				...postData
			};

			/* Keep it clean, we store it but we don't need to send these */
			delete formSubmissionObj.Platform;
			delete formSubmissionObj.MediaChannel;
			/* Platforms are now PlatformIds for POST purposes */

			// add the briefID if applicable
			const BriefID = MasterCampaignsStore.getBriefID(this.state.postData.CampaignConfig.MasterCampaignID);
			if (BriefID) {
				formSubmissionObj.BriefID = BriefID;
			}

			return formSubmissionObj;
		}
		this.setState({ errors: { Errors: ["Please fill in all form fields."] }, showErrors: true }, () => {
			ErrorHelpers.displayErrors(formEl, this.state.errors);
		});
	};

	sendPostObject = (newRowObj) => {
		this.postObject = this.formDataObjForPost(newRowObj);
		if (this.postObject) {
			const updatedData = editCampaignData(this.postObject);
		}

		if (this.postObject === undefined) {
			this.setState({ loading: false });
		}
	};

	handleSubmit = (e) => {
		if (this.state.loading === false) {
			MasterCampaignsStore.resetAdvertisersErrors();
			this.setState({ loading: true, totalAdvertisers: 0 }, () => {
				e.preventDefault();
				this.sendPostObject(this.state.formData);
			});
		}
	};

	handleReset = () => {
		ErrorHelpers.resetErrors(formEl);
	};

	checkForEmptyPlatforms = () => {
		const rows = this.state.additionalRows.length;
		for (let i = 1; i <= rows; i++) {
			if (this.state.formData[`MediaChannel_${i}`] !== undefined) {
				if (this.state.formData[`Platform_${i}`] === undefined) {
					this.handleAdditionalMediaChannelRemoval(null, null, i);
				}
			}
		}
	};

	handleErrors = () => {
		this.setState({ loading: false }, () => {
			this.checkForEmptyPlatforms();
			const errors = MasterCampaignsStore.getErrors();
			if (Object.keys(errors).length > 0) {
				const campaignErrors = errors.campaign;
				const type = "edit mastercampaign";
				this.setState({ errors: campaignErrors, showErrors: true }, () => {
					ErrorHelpers.displayErrors(formEl, this.state.errors, type);
				});
			}
		});
	};

	fetchAdvertiserFields = async (selections = []) => {
		// always request the advertisers already in props.data.Advertisers
		const advertiserPropIds = this.props?.data?.AvailableAdvertisers?.map((aa) => aa?.HierarchyLevelID) || [];

		// optionally include ones specified by the selections param - this is used when platforms are added in this modal (onMultiSelectPlatformChange)
		const ids = [...advertiserPropIds, ...selections.map(({ HierarchyLevelID }) => HierarchyLevelID)];

		const platformsToFetch =
			MasterCampaignsStore.getAdvertisers()?.filter?.((platform) => {
				const isEnabled = this.props.enabledPlatformAPIs?.find(({ MasterPlatformID }) => MasterPlatformID === platform?.MasterPlatformID)?.SyncStatus === false;
				return ids.includes(platform.HierarchyLevelID) && !this.state.loadedAdvertiserIds?.includes?.(platform.HierarchyLevelID) && isEnabled;
			}) || [];

		if (platformsToFetch.length > 0) {
			this.setState({ loading: true });
			await fetchAdvertiserTaxonomy(platformsToFetch);
			this.setState({
				advertiserFields: MasterCampaignsStore.getAdvertiserFields(),
				loadedAdvertiserIds: [...this.state.loadedAdvertiserIds, ...ids],
				loading: false
			});
		} else {
			this.setState({ advertiserFields: MasterCampaignsStore.getAdvertiserFields(), loading: false });
		}
	};

	/* Needed for all Modals */
	triggerOpenClose = (event) => {
		if (this.state.loading === false) {
			ModalHelpers.openCloseCLModal(event, this.updateModalState, this.state, initialState, () => {
				ErrorHelpers.resetErrors(formEl);
				if (!this.state.open) {
					this.setState({ loading: true }, async () => {
						const modals = document.getElementsByClassName("bx--modal-content");
						if (modals) {
							for (const modal of modals) {
								if (modal.style.overflow !== "auto") {
									modal.style.overflow = "auto";
								}
							}
						}
						await this.fetchAdvertiserFields();
						this.fillFields();
					});
				} else {
					this.removeAdvertiserFields();
				}
			});
		}
	};

	fillFields = () => {
		this.matchData();
		this.matchMediaChannelData();
		this.matchPermissionedOptions();
		Object.keys(MasterCampaignsStore.getAdvertiserFields()).forEach((advertiserName) => {
			if (!this.state[advertiserName]) {
				this.setState({ [advertiserName]: { formData: {}, postData: {} } }, () => {
					this.matchAdvertiserData(advertiserName);
				});
			}
		});

		this.setState({ disabledRows: Object.keys(this.props.data.ActivationCampaigns).length, loading: false });
	};

	matchPermissionedOptions = () => {
		const permissionedOptions = {};
		const selectedOptions = this.props.data?.AvailableDataKeyDataValuePermissions?.map((option) => {
			return option.DataValue_MDM_GUID;
		});
		Object.keys(this.props.permissionedDataKeys).forEach((dataKey) => {
			this.props.permissionedDataKeys[dataKey].forEach((option) => {
				if (selectedOptions.includes(option.DataValue_MDM_GUID)) {
					if (!permissionedOptions[dataKey]) {
						permissionedOptions[dataKey] = [option];
					} else {
						permissionedOptions[dataKey] = [...permissionedOptions[dataKey], option];
					}
				}
			});
		});
		this.setState({ permissionedOptions });
	};

	matchMediaChannelData = () => {
		let count = 0;
		const formData = JSON.parse(JSON.stringify(this.state.formData));
		const postData = JSON.parse(JSON.stringify(this.state.postData));
		postData.MasterCampaignID = this.props.data.MasterCampaignUniqueIDCode;
		const additionalRows = JSON.parse(JSON.stringify(this.state.additionalRows));
		const excludedPlatformIDs = JSON.parse(JSON.stringify(this.state.excludedPlatformIDs));
		const formDataAll = [];
		const postDataAll = [];
		this.props.data.AvailableActivations.forEach((platformInEdit) => {
			this.props.mediaChannelsPlatforms.forEach((platform) => {
				if (platform.PlatformName === platformInEdit.PlatformName && platform.MasterPlatformID === platformInEdit.MasterPlatformID) {
					const plat = `Platform_${count}`;
					formDataAll.push({ label: platform.PlatformName, value: platform.MasterPlatformID });
					postDataAll.push({ label: platform.PlatformName, value: platform.MasterPlatformID });

					if (count !== 0) {
						additionalRows.push({ id: count, platformsDisabled: true });
					}
					excludedPlatformIDs.push(platform.MasterPlatformID);
					count++;
				}
			});
		});
		formData[`Platform_${0}`] = formDataAll;
		postData[`Platform_${0}`] = postDataAll;
		const campaignConfig = { CampaignConfig: postData };
		this.setState({
			postData: campaignConfig,
			formData,
			additionalRows,
			excludedPlatformIDs
		});
	};

	matchData = () => {
		this.handleReset();
		const configObjs = Object.entries(this.props.config);
		for (const dataBucket of configObjs) {
			if (dataBucket[0] !== "ParentData" && dataBucket[0] !== "ChildData") {
				for (const field of dataBucket[1]) {
					if (this.props.data !== undefined) {
						if (this.props.data.hasOwnProperty(field.Name)) {
							setTimeout(() => {
								if (field.DataType === "Select") {
									let optionID = this.props.data[`${field.Name}ID`];

									const fieldItem = dataBucket[1].filter((a) => a.Name == field.Name);
									if (fieldItem.length > 0) {
										const optionItem = fieldItem[0].Options.filter((a) => a.OptionLabel == this.props.data[field.Name]);
										if (optionItem.length > 0) {
											optionID = optionItem[0].OptionID;
										}
									}

									// Populate Drop Down Fields
									// There are only 7 Parameters accepted: see updateState below to match
									if (optionID != undefined && optionID > 0) {
										this.updateState(
											dataBucket[0],
											field.Name,
											{ value: optionID, label: this.props.data[field.Name] },
											field.ID,
											field.DataType,
											false,
											false
										);
									}
								} else {
									// Populate Free Text Fields
									// There are only 7 Parameters accepted: see updateState below to match
									this.updateState(dataBucket[0], field.Name, this.props.data[field.Name], field.ID, field.DataType, false, false);
								}
							}, 0);
						}
					}
				}
			}
		}
	};

	updateModalState = () => {
		this.rowCount = 0;
		this.setState({
			open: !this.state.open,
			...initialState,
			additionalRows: [
				{
					id: this.rowCount,
					platformsDisabled: true
				}
			],
			mediaChannelsPlatforms: this.props.mediaChannelsPlatforms,
			excludedPlatformIDs: [],
			permissionedOptions: {}
		});
	};
	/* END */

	notifyCampaignSuccess = () => {
		if (!this.pendingMasterCampaignSuccess) {
			return;
		}
		showToast(
			// this comment exists to prevent eslint from making this unreadable.
			"masterCampaignToasts",
			<ToastNotification type="success" message="The selected primary campaign information has been successfully updated" timed={9000} />
		);
		this.pendingMasterCampaignSuccess = false;
	};

	handleSuccess = () => {
		this.pendingMasterCampaignSuccess = true;
		ErrorHelpers.resetErrors(formEl);
		MasterCampaignsStore.resetSelectedCampaigns();
		this.addAdvertiserData();
	};

	deleteFormDataDynamically = (formData, id) => {
		delete formData[`Platform_${id}`];
		return formData;
	};

	deletePostDataDynamically = (postData, id) => {
		delete postData.CampaignConfig[`Platform_${id}`];
		return postData;
	};

	rebuildExclusionList = () => {
		const idsToExclude = [];
		const currentFormData = Object.entries(this.state.formData);
		currentFormData.forEach((element) => {
			if (element[0].indexOf("Platform") !== -1) {
				if (typeof element[1] !== "undefined" && element[1] !== null) {
					element[1].forEach((x) => {
						idsToExclude.push(x.value);
					});
				}
			}
		});

		return idsToExclude;
	};

	removePlatformFromExclusion = (id) => {
		const excludedIDs = this.state.excludedPlatformIDs;
		if (id) {
			if (this.state.formData[`${id}`]) {
				const platformID = this.state.formData[`${id}`].value;
				for (let i = 0; i < excludedIDs.length; i++) {
					if (excludedIDs[i] === platformID) {
						excludedIDs.splice(i, 1);
					}
				}
			}
		}

		return excludedIDs;
	};

	handleAdditionalMediaChannelRemoval = (e, item, id) => {
		if (e) {
			e.preventDefault();
		}
		if (this.state.formData[`Platform_${id}`]) {
			if (this.state.formData[`Platform_${id}`].value) {
				if (this.state.formData[`Platform_${id}`].value.label) {
					if (this.state[this.state.formData[`Platform_${id}`].value.label]) {
						delete this.state[this.state.formData[`Platform_${id}`].value.label];
					}
				}
			}
		}

		const excludedIDs = this.removePlatformFromExclusion(`Platform_${id}`);
		const additionalRows = this.state.additionalRows.filter((i) => i.id !== id);
		const formData = this.deleteFormDataDynamically(this.state.formData, id);
		const postData = this.deletePostDataDynamically(this.state.postData, id);

		this.setState({
			additionalRows,
			excludedPlatformIDs: excludedIDs,
			formData,
			postData
		});
	};

	renderAdvertiserFields = () => {
		const platforms = this.state.formData.Platform_0 || [];

		return platforms.map(({ label: platformLabel, value }) => {
			// const { label: platformLabel, value } = platform || {};
			const advertiser = this.state.advertiserFields[platformLabel];
			if (advertiser) {
				if (this.state.formData.Platform_0 && this.state.advertiserFields?.[platformLabel]) {
					let disableFields = false;
					const matchingAdvertiserTaxonomy = this.props?.data?.Advertisers?.[platformLabel]?.[0];
					if (matchingAdvertiserTaxonomy?.IsPlatformAdvertiserUsed === "1") {
						disableFields = true;
					}
					return (
						<AdvertiserFormBuilder
							type={`edit ${platformLabel}`}
							data={this.state.advertiserFields[platformLabel]}
							configName="CampaignConfig"
							onUpdate={(...args) => {
								this.updateAdvertiserState(...args);
								this.setState({ isFormInitialLoad: false }, () => {
									this.isFormValid();
								});
							}}
							state={this.state[platformLabel]}
							errors={this.state.advertisersErrors}
							advertiser={platformLabel}
							disableFields={disableFields}
						/>
					);
				}
				if (this.state.formData.Platform_0 && !this.state.advertiserFields?.[platformLabel]) {
					return <></>;
				}
			}
		});
	};

	matchAdvertiserData = (advertiserName) => {
		if (this.props.data.Advertisers[advertiserName] && this.props.data.Advertisers[advertiserName].length !== 0) {
			const configObjs = Object.entries(this.state.advertiserFields[advertiserName]);
			for (const dataBucket of configObjs) {
				if (dataBucket[0] !== "AdvertiserData") {
					for (const field of dataBucket[1]) {
						if (this.props.data.Advertisers[advertiserName][0].hasOwnProperty(field.Name)) {
							if (field.DataType === "Select") {
								let optionID = this.props.data.Advertisers[advertiserName][0][`${field.Name}ID`];
								let fieldLabel = this.props.data.Advertisers[advertiserName][0][field.Name];
								const fieldItem = dataBucket[1].filter((a) => a.Name == field.Name);
								if (fieldItem.length > 0) {
									const optionItem = fieldItem[0].Options.filter((a) => a.OptionLabel == this.props.data.Advertisers[advertiserName][0][field.Name]);
									if (optionItem.length > 0) {
										optionID = optionItem[0].OptionID;
									}
								}

								if (optionID === undefined) {
									let dataValueID = null;
									const previousTaxonomyData = this.props?.data?.Advertisers[advertiserName][0]?.TaxonomyData
										? JSON.parse(this.props.data.Advertisers[advertiserName][0].TaxonomyData)
										: [];
									const previousMetaData = this.props?.data?.Advertisers[advertiserName][0]?.MetaData
										? JSON.parse(this.props.data.Advertisers[advertiserName][0].MetaData)
										: [];
									previousTaxonomyData.forEach((taxonomyField) => {
										if (taxonomyField.DataKeyShortDescr === field.Label) {
											dataValueID = taxonomyField.DataValue.DataValueID;
										}
									});
									if (dataValueID === null) {
										previousMetaData.forEach((metaDataField) => {
											if (metaDataField.DataKeyShortDescr === field.Label) {
												dataValueID = metaDataField.DataValue.DataValueID;
											}
										});
									}
									if (dataValueID !== null) {
										const changedMatchingOption = field.Options.filter((option) => option.OptionID === dataValueID.toString());
										if (changedMatchingOption[0] !== undefined) {
											optionID = changedMatchingOption[0].OptionID;
											fieldLabel = changedMatchingOption[0].OptionLabel;
										}
									}

									// if optionID is STILL undefined by this point, likely was filtered from TX entirely - grab it from previous TX (7801 fix)
									// manually check if the advertiser is disabled (used) aswell to limit the case further to 7801 specific report.
									if (optionID === undefined && this.props.data.Advertisers[advertiserName][0].IsPlatformAdvertiserUsed === "1") {
										previousTaxonomyData?.forEach((taxonomyField) => {
											if (taxonomyField?.DataKeyShortDescr === field?.Label) {
												optionID = taxonomyField?.DataValue?.DataValueID;
												fieldLabel = taxonomyField?.DataValue?.DataValueDescription;
											}
										});
									}
								}

								// Populate Drop Down Fields
								// There are only 7 Parameters accepted: see updateState below to match
								if (optionID != undefined && optionID > 0) {
									this.updateAdvertiserState(dataBucket[0], field.Name, { value: optionID, label: fieldLabel }, field.ID, field.DataType, advertiserName);
								}
							} else {
								// Populate Free Text Fields
								// There are only 7 Parameters accepted: see updateState below to match
								this.updateAdvertiserState(
									dataBucket[0],
									field.Name,
									field.DataType === "Date"
										? moment(this.props.data.Advertisers[advertiserName][0][field.Name]).format("YYYY/MM/DD")
										: this.props.data.Advertisers[advertiserName][0][field.Name],
									field.ID,
									field.DataType,
									advertiserName
								);
							}
						}
					}
				}
			}
		}
	};

	updateAdvertiserState = (dataConfig, name, value, id, dataType, advertiser) => {
		// if (this.state.loading === false) {
		UpdateStateHelper.updateAdvertiserFields(dataConfig, name, value, id, dataType, formEl, this, advertiser, this.state.advertiserFields[advertiser]);
		// }
	};

	addAdvertiserData = () => {
		const advertiserKeys = Object.keys(this.state.advertiserFields);
		const postObjectArray = [];
		advertiserKeys.forEach((key) => {
			// Have to check if it was successfully created before, if so it's an edit
			if (this.state[key]) {
				const postData = { ...this.state[key].postData };
				const strippedTaxonomyPostData = [];
				for (const i in this.state[key].postData.TaxonomyData) {
					strippedTaxonomyPostData.push(postData.TaxonomyData[i]);
				}
				const strippedMetadataPostData = [];
				for (const i in this.state[key].postData.MetaData) {
					strippedMetadataPostData.push(postData.MetaData[i]);
				}
				if (strippedMetadataPostData.length + strippedTaxonomyPostData.length > 0) {
					postData.MetaData = strippedMetadataPostData;
					postData.TaxonomyData = strippedTaxonomyPostData;
					const contextValues = BookFiltersStore.getContextValues();
					let auditLevelID = null;
					let platformID = null;
					MasterCampaignsStore.getAdvertisers().forEach((advertiser) => {
						if (key === advertiser.PlatformName) {
							auditLevelID = advertiser.HierarchyLevelID;
							platformID = advertiser.MasterPlatformID;
						}
					});

					let advertiserID = 0;
					let platformAdvertiserPK = null;
					if (this.props.data.Advertisers[key]) {
						if (this.props.data.Advertisers[key].length !== 0) {
							advertiserID = this.props.data.Advertisers[key][0].AdvertiserUniqueCode;
							platformAdvertiserPK = this.props.data.Advertisers[key][0].PlatformAdvertiserPK;
						}
					} else if (MasterCampaignsStore.getAdvertiserEditSuccess()[key]) {
						advertiserID = MasterCampaignsStore.getAdvertiserEditSuccess()[key].AdvertiserID;
						platformAdvertiserPK = MasterCampaignsStore.getAdvertiserEditSuccess()[key].PlatformAdvertiserPK;
					}
					const formSubmissionObj = {
						MasterAgencyDivisionName: contextValues?.agency?.name,
						MasterBusinessUnitName: contextValues?.client?.name,
						MasterCountryCode: contextValues?.country?.name,
						ContextID: contextValues.contextId,
						MasterRegionCode: contextValues?.region?.name,
						AuditLevelID: auditLevelID,
						PlatformID: platformID,
						AdvertiserData: {
							MasterCampaignID: this.props.data.MasterCampaignUniqueIDCode,
							MasterPlatformID: platformID,
							AdvertiserID: advertiserID,
							PlatformAdvertiserPK: platformAdvertiserPK
						},
						...postData
					};
					if (this.state.excludedPlatformIDs.includes(platformID)) {
						postObjectArray.push([key, formSubmissionObj, "edit"]);
					}
				}
			}
		});
		if (postObjectArray.length === 0) {
			this.setState({ loading: false, additionalRows: [], disabledRows: 0, excludedPlatformIDs: [] }, () => {
				this.notifyCampaignSuccess();
				this.triggerOpenClose();
				this.props.reloadGrid();
			});
		} else {
			this.setState({ totalAdvertisers: postObjectArray.length }, async () => {
				try {
					// remove advertisers that match IsPlatformAdvertiserUsed == 1 from the postObjectArray, as these cannot be edited in this modal
					const validatedObjectArray = postObjectArray?.filter(([platformLabel]) => {
						const matchingAdvertiserTaxonomy = this.props?.data?.Advertisers?.[platformLabel]?.[0];
						return matchingAdvertiserTaxonomy?.IsPlatformAdvertiserUsed !== "1";
					});
					const { values, errors } = await createAdvertisers(validatedObjectArray, "update");
					if (Object.keys(errors || {}).length === 0) {
						this.handleAdvertiserSuccess();
					}
				} finally {
					this.setState({ loading: false });
				}
			});
		}
	};

	handleAdvertiserSuccess = () => {
		this.setState({ totalAdvertisers: 0, loading: false }, () => {
			this.notifyCampaignSuccess();
			this.props.reloadGrid();
			this.triggerOpenClose();
		});
	};

	handleAdvertiserErrors = () => {
		this.pendingMasterCampaignSuccess = false;
		this.setState({ loading: false, advertisersErrors: {} }, () => {
			this.checkForEmptyPlatforms();
			Object.keys(MasterCampaignsStore.getAdvertiserErrors()).forEach((advertiserField) => {
				const errors = MasterCampaignsStore.getAdvertiserErrors()[advertiserField] || {};
				if (Object.keys(errors).length > 0) {
					const { advertisersErrors } = this.state;
					advertisersErrors[advertiserField] = {};
					Object.keys(errors).forEach((errorFieldName) => {
						errors[errorFieldName].forEach((errorName) => {
							advertisersErrors[advertiserField][errorFieldName] = errorName;
						});
					});
					this.setState({ advertisersErrors });
				}
			});
		});
	};

	removeAdvertiserFields = () => {
		Object.keys(this.state.advertiserFields).forEach((advertiser) => {
			if (this.state[advertiser]) {
				delete this.state[advertiser];
			}
		});
		MasterCampaignsStore.resetAdvertisersErrors();
		MasterCampaignsStore.resetAdvertisersSuccess();
		MasterCampaignsStore.resetAdvertiserEditSuccessObj();
		this.setState({ advertisersErrors: {} });
	};

	render() {
		const isDisabled = this.state.loading ? "disabledModal" : "";
		if (this.props.config && this.props.config.CampaignConfig[0]) {
			this.props.config.CampaignConfig[0].Label = "Campaign Name";
		}
		return (
			<>
				<Modal
					size={MODAL_SIZE.MEDIUM}
					id="edit__master__campaign"
					className={`master--campaign ${isDisabled}`}
					heading="Edit Primary Campaign"
					description={"Modify the campaign name and adjust your preferred platforms. Click 'Save' to apply the changes instantly."}
					isOpen={this.state.open}
					onRequestClose={() => {
						if (this.state.open) {
							this.triggerOpenClose();
						}
					}}
					userClosable={true}
					onClick={() => {}}
					actionSetProps={{
						actionsRight: (
							<>
								<Button display="secondary" onClick={this.triggerOpenClose} data-tracking-id-alt="cancel-edit-master-campaign">
									Cancel
								</Button>
								<Button display="primary" disabled={!this.state.isFormDataValid} onClick={this.handleSubmit} data-tracking-id-alt="confirm-edit-master-campaign">
									Save
								</Button>
							</>
						)
					}}
				>
					{this.state.loading && <Loading className="modalLoading" />}
					<form className="createCampaign" autoComplete="off">
						<div className="campaign-config-container">
							<FormBuilderV2
								type="edit mastercampaign"
								data={this.props.config}
								configName="CampaignConfig"
								onUpdate={this.updateState}
								state={this.state}
								auditLevelID={this.props.auditLevelID}
							/>
							<div className="platform_container">
								<Dropdown
									className="selectPlatform"
									placeholder="Select Platform..."
									name={`Platform_${0}`}
									onChange={this.onMultiSelectPlatformChange}
									options={this.filterPlatforms(this.state.mediaChannelsPlatforms)}
									dataConfig={"CampaignConfig"}
									value={this.state.formData[`Platform_${0}`] ? this.state.formData[`Platform_${0}`] : null}
									isClearable={true}
									id={`Platform_${0}`}
									multiple={true}
									required={true}
									isSearchable={true}
									closeMenuOnSelect={true}
								>
									Activation Platforms
								</Dropdown>
							</div>
						</div>
						<div className="advertiser-fields-container">{this.renderAdvertiserFields()}</div>
						<AccessPermissions
							type="master"
							permissionedOptions={this.state.permissionedOptions}
							onChange={(value, dataKey) => {
								const { permissionedOptions } = this.state;
								permissionedOptions[dataKey] = value;
								this.setState({ permissionedOptions }, () => {
									this.isFormValid();
								});
							}}
						/>

						{this.state.showErrors && <div id="errors__container" />}
						<div className={"_m-t--70 _m-b--70"} />
					</form>
				</Modal>
			</>
		);
	}
}

export default EditMasterCampaign;
